import { TraceLogger } from 'one-trace-logger';

export const enableTrace = (
    key: string,
    options: any,
    cb?: (url: string) => void) => {

    const { log, settings } = options;
    const { trace = {} } = settings;
    const { url, users } = trace;

    if (users) {
        for (const user of users) {
            if (user === key) {
                if (cb) {
                    cb(url);
                } else {
                    if (log) {
                        log.add(new TraceLogger(url, key));
                    }
                }
                break;
            }
        }
    }

    // if (users.find((u: any) => (u === key))) {
    //     if (cb) {
    //         cb(url);
    //     } else {
    //         if (log) {
    //             log.add(new TraceLogger(url, key));
    //         }
    //     }
    // }
}
